<template>
  <div class="preview" ref="preview">
    <div class="box" v-for="(val,key) in content" v-bind:key="key" >
      <div v-if="val.type=='title'" >
        <textarea :class="val.class" rows="1" cols="30" v-model="val.title"></textarea>
        <div class="done">
          <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
          <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
<!--          <span>添加</span>-->
          <span @click.stop="del(val,key)">删除</span>
        </div>
      </div>
      <div v-if="val.type=='text'" >
        <textarea :class="val.class"  rows="4" cols="30" style="text-indent: 30px;" v-model="val.text"></textarea>
        <div class="done">
          <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
          <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
<!--          <span>添加</span>-->
          <span @click.stop="del(val,key)">删除</span>
        </div>
      </div>
      <div v-if="val.type=='img'" @click="edit(key)" >
        <img :src="val.url" :class="val.class">
        <div class="done">
          <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
          <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
<!--          <span>添加</span>-->
          <span @click.stop="">
                  <el-upload style="display: inline-block"
                             class=""
                             :http-request="img_put"
                             :data="key"
                             :before-upload="upload_check" accept=".jpg,.png"
                             :show-file-list="false">
                    插入图片
                  </el-upload>
                </span>
          <span @click.stop="del(val,key)">删除</span>
        </div>
        <template v-for="(vals,k) in val.item">
          <div :key="k" :style="{'left':vals.x_axis+'%','top':vals.y_axis+'%','position': 'absolute',}"
               class="point">{{vals.is_show==1 ? vals.title : ''}}</div>
        </template>
      </div>
      <div v-if="val.type=='video'" >
        <video :src="val.url" controls :class="val.class"></video>
        <div class="done">
          <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
          <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
          <span >
<!--            <el-upload style="display: inline-block;background:#fff;height: 28px;" :http-request="video_upload"-->
<!--                       :data="{k:key}" :accept="accept"-->
<!--                       :show-file-list="false">-->
              <el-button size="small" style="border: 0;padding: 0;color: #409eff;" @click="repalce(key)">替换
              </el-button>
<!--            </el-upload>-->
          </span>
          <span @click.stop="del(val,key)">删除</span>
        </div>
      </div>
      <div v-if="val.type=='swiper'" @click="edit(key)" style="position:relative;">
        <img :src="val.data[0]" :class="val.class">
        <div class="banner">
          <template  v-for="(val,key) in val.data">
            <span class="circle" :style="key==0 ? 'background:#409eff' : '' " v-bind:key="key" ></span>
          </template>
        </div>
        <div style="position:absolute;top: 50%;left: 50%;font-size: 40px;transform: translate(-50%,-50%);">轮播图</div>
        <div class="done">
          <span class="iconfont icon-xiangshangjiantou" @click.stop="top_move(key)"></span>
          <span class="iconfont icon-xiangxiajiantou" @click.stop="down_move(key)"></span>
<!--          <span>添加</span>-->
          <span @click.stop="del(val,key)">删除</span>
        </div>
      </div>
    </div>
    <LayerPop title="编辑图片" @close="vue_pop_show_hide" v-if="is_pop">
      <swiper_edit v-if="content[key]['type']=='swiper'" :swiper="content[key]" v-model="content[key]"
                   @swiper_submit="submit"></swiper_edit>
      <img_edit v-if="content[key]['type']=='img'" :img="content[key]"
                v-model="content[key]" @img_submit="submit"></img_edit>
    </LayerPop>
    <layer-pop title="音视频" @close="is_upload=false" v-if="is_upload">
      <upload-list @submit="video_choose"></upload-list>
    </layer-pop>
  </div>
</template>

<script>
import LayerPop from "@/components/layer-pop";
import swiper_edit from "@/components/one_page/swiper_edit";
import img_edit from "@/components/one_page/img_edit";
import UploadList from "@/components/upload/upload-list.vue";
export default {
  name: "one_page_preview",
  components:{UploadList, LayerPop,swiper_edit,img_edit},
  model:{prop:'content' ,event:'change'},
  props:{
    content : {type : String, default : ''},
    data : {type : Object, default : function (){return {}}},
  },
  data(){
    return{
      img:'https://weiye.weipaiyuan.cn/ex.jpg',
      is_pop:false,
      key:'',
      accept:'video/*',
      dir : [],
      is_upload:false,
      k:'',
    }
  },
  methods:{
    del:async function (val,key){
      console.log(val,key);
      let res =await this.$_confirm('确认删除？','删除',);
      if(res){
        console.log(val,key);
        this.content.splice(key,1);
        this.$emit('change',this.content);
      }
    },
    top_move:function (key){
      if(key==0){
        return;
      }
      if(key != 0){
        this.content[key] = this.content.splice(key-1,1,this.content[key])[0];
      }else{
        this.content.push(this.content.shift());
      }
      this.$emit('change',this.content);
    },
    down_move:function (key){
      if(key >= this.content.length-1){
        return;
      }
      if(key != this.content.length-1){
        this.content[key] = this.content.splice(key+1,1,this.content[key])[0];
      }else{
        this.content.unshift(this.content.splice(key,1)[0])
      }
      this.$emit('change',this.content);
    },
    edit:function (key){
      this.is_pop = true;
      this.key=key;
    },
    repalce:function (k){
      this.k = k;
      this.is_upload = true;
    },
    video_choose:function (e){
      this.is_upload = false;
      this.content[this.k].url = e.url;
    },
    video_upload:async function (e){
      try{
        console.log(e);
        console.log(e.file);
        // console.log(this.content[e.file.data]);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file, 'file','',this.user.uid);
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          this.content[e.data.k].url = res.url;
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    img_put:async function (e){
      try {
        console.log(e);
        console.log(e.data);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'img','',this.user.uid);
          this.$_hideLoading();
          // this.$_showToast(res.errmsg,res.style);
          let data = {type:'img',url:res.url,class:'web_img',item:[],filename:res.filename};
          this.content.splice(e.data+1,0,data);
        }
      }catch (e) {
        console.log(e)
      }
    },
    upload_check:function (e){
      let that = this;
      console.log(e);
      let check_img = new Promise(function (resolve, reject){
        let _url = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = function (){
          //检查比例
          //   if ((image.width / image.height) == (3 / 5)){
          //     that.$_showToastNone('图片宽高比例必须是3:5');
          //     reject();
          //   }
          let size = image.size / 1024 /1024;
          if (size > 5){
            that.$_showToastNone('最大只能上传5M');
            reject();
          }
          resolve();
        }
        image.src = _url.createObjectURL(e);
      })
      return check_img;
    },
    submit:function (){
      this.is_pop = false;
    }
  }
}
</script>

<style scoped>
.preview{
  /*border: 1px solid #dcdfe6;*/
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  margin: 0 auto;
  padding: 20px 0;
  color: #999;
  width: 550px;
  height: 800px;
  overflow: auto;
}
.box{
  border: 1px dashed #dcdfe6;
  text-align: center;
  cursor: pointer;
}
.box > div{position: relative;}
.box:hover{
  color: #409eff;border: 1px dashed #409eff;
}
.box:hover .done{display: inline-block}

.done{position: absolute;display: none;right:0;top:-15px;height:30px;line-height: 30px;background: #fff;border-radius: 4px;box-shadow: #eee 0 0 2px 1px;font-size: 14px;
}
.done span{padding: 0 10px;border-right:1px solid #eee;}

.banner{
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  height: 30px;
  align-items: center;
}
.circle{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #eee;
  display: inline-block;
  margin: 10px 5px;
}
/*.point{*/
/*  position: absolute;box-shadow: 0 0 5px #fff;*/
/*  !*border: 1px solid #fff;*!*/
/*  border-radius: 50px;padding: 2px 8px;cursor: default;*/
/*}*/
.point{
  position:absolute;
  padding:0 12px;
  height: 24px;
  line-height: 24px;
  background:rgba(38,34,33,.7);
  border-radius:20px;
  font-size:12px;
  color:#ffffff;
  z-index:99;
  transform:translateX(8px)translateY(-50%);
}

.point::after{
  left:-12px;
  content:"";
  display:block;
  position:absolute;
  width:8px;
  height:8px;
  border-radius:50%;
  background:rgba(0,0,0,.2);
  top:50%;
  transform:translateY(-50%);
}
img{display: block;}
textarea{width: 99%;border: 0;outline:none;resize:none;padding: 10px 2px;}
.web_title{font-weight: bold;font-size: 26px;text-align: center;}
.web_text{font-size: 18px;color: #666;}
.web_img{width: 100%;height: auto;}
.web_video{width: 100%;}
.web_swiper{width: 100%;}
</style>